import { Box, Skeleton } from '@mui/material';

export default function EventDashboardSkeleton() {
    return (
        <Box
            sx={{
                bgcolor: 'var(--primary-color)',
                flex: 1,
                height: '92vh',
                display: 'flex',
                padding: '1rem 2rem',
                gap: '1rem'
            }}
        >
            <Skeleton
                variant="rounded"
                // height={330}
                width={300}
                sx={{
                    alignSelf: 'stretch',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.4)',
                    borderRadius: '2rem'
                }}
            />

            <Skeleton
                variant="rounded"
                // height={330}
                sx={{
                    flex: '1',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.4)',
                    borderRadius: '2rem'
                }}
            />
        </Box>
    );
}
